import { render, staticRenderFns } from "./CollectDetail.vue?vue&type=template&id=7e6ce027&scoped=true"
import script from "./CollectDetail.vue?vue&type=script&lang=js"
export * from "./CollectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6ce027",
  null
  
)

export default component.exports